import { ActionIcon, Flex, Paper, Text } from '@mantine/core';
import { IconArrowUpRight, IconCashBanknote } from '@tabler/icons-react';
import { NavLink } from 'react-router';
import dayjs from 'dayjs';
import { formatCurrencyPaymentPeriod } from '@shared/helpers';

type VacancyCardProps = {
  id: number;
  name: string;
  region: string;
  salaryFrom: number;
  salaryTo: number;
  currency: string;
  createdAt: string;
  paymentPeriod: string;
};

export const VacancyCard = ({
  id,
  name,
  region,
  salaryFrom,
  salaryTo,
  currency,
  createdAt,
  paymentPeriod,
}: VacancyCardProps) => {
  const formattedPeriod = formatCurrencyPaymentPeriod(currency, paymentPeriod);

  return (
    <Paper p={16} radius={12} bg='primary.0' w='100%'>
      <Flex direction='column' gap={24}>
        <Flex gap={8} align='center' wrap='wrap'>
          <Flex gap={4} direction='column' flex={1}>
            <Text c='primary.7'>{name}</Text>
            <Text size='sm' c='tertiary.7'>
              {region}
            </Text>
          </Flex>

          <ActionIcon component={NavLink} to={`/vacancy-list/${id}`}>
            <IconArrowUpRight
              size={24}
              color='var(--mantine-color-primary-7)'
            />
          </ActionIcon>
        </Flex>

        <Flex gap={8} align='center' wrap='wrap'>
          <IconCashBanknote size={24} />

          <Text c='primary.7'>
            {`${salaryFrom} - ${salaryTo} ${formattedPeriod}`}
          </Text>
        </Flex>

        <Flex gap={16} align='center' wrap='wrap' justify='flex-end'>
          <Text size='sm' c='tertiary.7'>
            {dayjs(createdAt).format('DD.MM.YYYY')}
          </Text>
        </Flex>
      </Flex>
    </Paper>
  );
};
